import { ObjectValues } from 'types';
import { DealStage } from './DealRoom';
import { Industry } from './Industry';

export type EnterpriseAnalyticsSummary = {
  liveDealsCount: number; // Link deals
  dealsWithListingCount: number; // Link listings
  totalProjectedSaleValue: number; // Gross stock value
  totalProjectedSuccessFee: number; // Commission pipeline
  totalProjectedFranchisorFee: number; // Projected franschisor fees
  activeTeamMembers: number; // Active brokers with at least one deal
  brokersInvitedCount: number; // Brokers invited
  teamMembersWithoutDeal: number; // Team members without a deal
};

export type EnterpriseAnalyticsDealRoomsByStatus = {
  stage: DealStage;
  count: number;
};

export type EnterpriseAnalyticsDealRoomsByIndustry = {
  industry: Industry;
  count: number;
  percentage: number;
};

export const TIMEFRAME = {
  LAST_7_DAYS: 'last7Days',
  LAST_30_DAYS: 'last30Days',
  THIS_MONTH: 'thisMonth',
  THIS_YEAR: 'thisYear',
} as const;

export type Timeframe = ObjectValues<typeof TIMEFRAME>;

const LEADS_ACTIVITY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

type LeadsActivityStatus = ObjectValues<typeof LEADS_ACTIVITY_STATUS>;

export type LeadsActivityAggregationItem = {
  status: LeadsActivityStatus;
  percentage: number;
  count: number;
};

export type LeadsActivityAggregationResponse = LeadsActivityAggregationItem[];
